import { defineElement, FC, onDidLoad, useElement, useProp } from '@atomify/hooks';
import { h } from '@atomify/jsx';
import { ButtonRound } from '@atoms/button-round/button-round';
import { useStore } from '@bpd-library/utilities';
import { getUserWishlist, UserState, userStore } from '@source/store/user';
import { useStylesheet } from '@utilities/hooks';

import style from './wishlist-favourite-button.scss';

const WishlistFavouriteButton: FC = ({ element }) => {
    const [constructionNumberId] = useProp<string>('constructionNumberId', '');
    const [count] = useProp<number>('count', 0);
    const [rendered, setRendered] = useProp<boolean>('rendered', false);
    const [, setIsFavourited, watchIsFavourited] = useProp<boolean>('isFavourited', false);
    const [, subscribe] = useStore<UserState>(userStore);

    const favouriteButtonCount = useElement<HTMLButtonElement>(
        '[js-hook-wishlist-favourite-button-count]',
    );

    useStylesheet(style);

    onDidLoad(() => {
        checkWishlist();
        setRendered(true);
    });

    subscribe(checkWishlist, ['wishlist']);

    watchIsFavourited((newIsFavourite, oldIsFavourite) => {
        if (newIsFavourite !== oldIsFavourite) {
            favouriteButtonCount.current!.innerText = `${newIsFavourite ? count + 1 : count}`;
        }
    });

    function checkWishlist() {
        const ids = getUserWishlist();

        const isFavourited = !!ids?.includes(constructionNumberId);

        setIsFavourited(isFavourited);
    }

    if (rendered) element.innerHTML = '';

    return (
        <bpd-wishlist-toggle-wrapper
            class="c-wishlist-favourite-button"
            construction-number-id={constructionNumberId}>
            <ButtonRound
                ariaLabel="Voeg toe aan wishlist"
                hook="wishlist-favourite-button"
                classes="wishlist-favourite-button__button"
                size="small"
                hasLoading>
                <bpd-svg name="icons-heart" />
                <span
                    class="wishlist-favourite-button__count"
                    js-hook-wishlist-favourite-button-count>
                    {count}
                </span>
            </ButtonRound>
        </bpd-wishlist-toggle-wrapper>
    );
};

WishlistFavouriteButton.props = {
    constructionNumberId: {
        type: String,
    },
    count: {
        type: Number,
    },
    isFavourited: {
        type: Boolean,
    },
    rendered: {
        type: Boolean,
        reflectToAttr: true,
    },
};

defineElement('bpd-wishlist-favourite-button', WishlistFavouriteButton);
